module.exports = __webpack_public_path__ + "img/10blue.6a19495c.png";